import React from 'react';
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from '../Home/HomeNav.jsx';
import HomeFooter from '../Home/HomeFooter.jsx';
import EventsIntro from './EventsIntro.jsx';
import Pagination from './Pagination.jsx';
import EventList from './EventList.jsx';
import MobilePagination from './MobilePagination.jsx';
const Events = () => {
  return <div className='font-figtree' data-sentry-component="Events" data-sentry-source-file="Events.jsx">
      <NextSeo {...seoFunct("eventsSeo")} data-sentry-element="NextSeo" data-sentry-source-file="Events.jsx" />
      <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="Events.jsx" />
      <EventsIntro data-sentry-element="EventsIntro" data-sentry-source-file="Events.jsx" />
      <EventList data-sentry-element="EventList" data-sentry-source-file="Events.jsx" />
      {/* <Pagination totalPages={10} /> */}
      {/* <MobilePagination totalPages={10} /> */}
      <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="Events.jsx" />
    </div>;
};
export default withRouter(Events);